const footerLinks = {
  Services: [
    'Office Cleaning',
    'Healthcare Facilities',
    'Post-Construction',
    'Eco-Friendly Cleaning',
    'Maintenance Plans',
  ],
  Company: ['About Us', 'Our Team', 'Careers', 'Press', 'Blog'],
  Resources: ['FAQ', 'Case Studies', 'Certifications', 'Contact'],
};

export default function Footer() {
  return (
    <footer className="bg-[#0d2218] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-[#4caf7d] rounded-md">
                <i className="ri-building-2-line text-white text-sm"></i>
              </div>
              <span
                className="font-bold text-lg tracking-tight"
                style={{ fontFamily: "'Syne', sans-serif" }}
              >
                DAS<span className="text-[#4caf7d]"> Cleaning</span>
              </span>
            </div>
            <p className="text-white/40 text-sm leading-relaxed max-w-xs mb-6">
              DAS Cleaning delivers premium commercial cleaning for corporate environments. Reliable, certified, and eco-conscious.
            </p>
            <div className="flex gap-3">
              {[
                { icon: 'ri-linkedin-fill', label: 'LinkedIn' },
                { icon: 'ri-facebook-fill', label: 'Facebook' },
                { icon: 'ri-instagram-line', label: 'Instagram' },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#"
                  rel="nofollow"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center border border-white/10 rounded-full text-white/40 hover:text-white hover:border-white/30 transition-colors duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-xs font-bold uppercase tracking-widest text-white/40 mb-4">
                {category}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      rel="nofollow"
                      className="text-sm text-white/50 hover:text-white transition-colors duration-150 cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} DAS Cleaning. All rights reserved.
          </p>
          <div className="flex gap-4">
            {['Privacy Policy', 'Terms of Service', 'Cookie Policy'].map((item) => (
              <a
                key={item}
                href="#"
                rel="nofollow"
                className="text-white/30 text-xs hover:text-white/60 transition-colors duration-150 cursor-pointer whitespace-nowrap"
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
